import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import FormikContainer from "../../../components/form/FormikContainer.jsx";
import genericTranslations from "../../../utils/genericTranslations.js";
import { selectSettings } from "../selectors.js";
import { fetchSettings, saveSettings } from "../thunks.js";

import SettingsForm, {
  MIN_BUS_JOURNEY_MAX_DISTANCE,
  MODULE,
} from "./SettingsForm.jsx";

const messages = {
  saved: {
    id: "modules.Settings.components.Settings.saved",
    description: "Settings saved confirmation.",
    defaultMessage: "Settings saved successfully.",
  },
  invalidValue: {
    id: "modules.Settings.components.Settings.invalidValue",
    description: "Invalid bus journey max distance validation message.",
    defaultMessage: "Enter a whole number greater than or equal to {min}.",
  },
};

const Settings = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const settings = useSelector(selectSettings);

  const [error, setError] = useState(false);
  const [saved, setSaved] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchSettings());
      } catch {
        setError(true);
      }
    };

    fetchData();
  }, [dispatch]);

  const initialValues = {
    busJourneyMaxDistance: settings?.[MODULE]?.busJourneyMaxDistance ?? "",
  };

  const validate = (values) => {
    const errors = {};
    const distance = Number(values.busJourneyMaxDistance);

    if (
      values.busJourneyMaxDistance === "" ||
      values.busJourneyMaxDistance === undefined ||
      !Number.isInteger(distance) ||
      distance < MIN_BUS_JOURNEY_MAX_DISTANCE
    ) {
      errors.busJourneyMaxDistance = intl.formatMessage(messages.invalidValue, {
        min: MIN_BUS_JOURNEY_MAX_DISTANCE,
      });
    }

    return errors;
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    setError(false);
    setSaved(false);

    try {
      await dispatch(
        saveSettings({
          [MODULE]: {
            busJourneyMaxDistance: Number(values.busJourneyMaxDistance),
          },
        }),
      );
      setSaved(true);
      setIsEditing(false);
    } catch {
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {error && (
        <Alert variant="danger" onClose={() => setError(false)} dismissible>
          {intl.formatMessage(genericTranslations.errorMessage)}
        </Alert>
      )}
      {saved && (
        <Alert variant="success" onClose={() => setSaved(false)} dismissible>
          {intl.formatMessage(messages.saved)}
        </Alert>
      )}

      <FormikContainer
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validate={validate}
        formComponent={SettingsForm}
        extraProps={{
          isEditing,
          onEdit: () => {
            setSaved(false);
            setIsEditing(true);
          },
          onCancel: () => setIsEditing(false),
        }}
      />
    </>
  );
};

export default Settings;
